import React, { Component } from "react";
import ChannelBox from "./ChannelBox";
import ChatStartButton from "./ChatStartButton";
import ContactFormButton from "./ContactFormButton";


import './InitialFormStyleSheet.css';

class InitialOfflinePage extends Component {

    constructor(props) {
        super(props);
        this.items = this.props.config && this.props.config.configDetails && !this.props.config.configDetails.offline && this.props.config.channels ?
            this.props.config.channels.sort((i1, i2) => { return i1.selposition - i2.selposition }) : []
    }

    render() {
        // Sort form items by selposition.
        return (
            <>
                
                <div className="s360-initial-channel-container" style={this.containerStyle()}>
                    <h4>{ this.props.config.configDetails.offlineIntroText}</h4>
                    
                </div>
              
            </>
        );

    }

    containerStyle = () => {
        return {
            backgroundColor: this.props.config.designDetails.pageBackgroundColor
        }
    }

    buttonStyle = () => {
        return {
            background: this.props.config.designDetails.formButtonBackground,
            color:      this.props.config.designDetails.formButtonColor,
            fontFamily:     this.props.config.designDetails.selectionButtonFont,
            fontSize:       this.props.config.designDetails.selectionButtonFontSize+"px",
        }
    }

    startChat = () => {
        // TODO: Add validations for fields.
        debugger;
        let invalidOptions = this.components.filter(component => { return !component.ref.current.validate() });
        const isValid = invalidOptions.length === 0;
        if (isValid) {
            let params = {};
            this.components.forEach(component => params = { ...params, ...component.ref.current.value() });
            this.props.actions.startChat(params);
        } else if (invalidOptions.length > 0) {
            let errorMessage = invalidOptions[0].ref.current.validationErrorMessage();
            this.props.actions.showPopUpMessage(errorMessage);
            invalidOptions[0].ref.current.focus = true;
        }
    }

}
export default InitialOfflinePage;